import React, { useState } from "react";
import FeatherIcon from "feather-icons-react";
import { ReactComponent as SearchIcon } from "../icons/search.svg";
import { useAppState } from "../../context/appContex";

interface GlobalSearchProps {
  handleSearch: (searchValue: string) => void;
  closeGlobalSearch: () => void;
}
const GlobalSearch: React.FC<GlobalSearchProps> = ({
  handleSearch,
  closeGlobalSearch,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const { menuData } = useAppState();

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (menuData) {
      window.location.href = `${menuData.system.homeMenuItem.targetUrl}&section=search&q=${searchValue}`;
    }
  };

  return (
    <div className='search-container'>
      <SearchIcon />
      <form style={{ width: "100%" }} onSubmit={onSubmit}>
        <input
          type='text'
          placeholder='Search'
          autoFocus
          value={searchValue}
          onChange={(e) => {
            handleSearch(e.target.value);
            setSearchValue(e.target.value);
          }}
        />
      </form>
      <FeatherIcon
        icon='x'
        onClick={() => {
          setSearchValue("");
          closeGlobalSearch();
        }}
      />
    </div>
  );
};

export default GlobalSearch;
